export default __webpack_public_path__ + "static/media/usage.e3f964dc.webp";